// src/api/saveMatch.ts
import { IMatchForm } from "../interfaces/Match";
import { API_ENDPOINTS } from "./config";
import { csrfFetch } from "./csrf";

export async function saveMatchLegs(form: IMatchForm) {
  const response = await csrfFetch(API_ENDPOINTS.saveMatch, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(form),
  });
  if (!response.ok) throw new Error("Fehler beim Speichern der Daten");
  return response.json();
}
